module.exports = __webpack_public_path__ + "static/media/photo196.9491ec39.jpg";